import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { accountingDealerFilterFields } from "./fields";

const AccountingDealerFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => accountingDealerFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={5} />;
};

export default AccountingDealerFilter;
